import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { from, Observable } from 'rxjs';

@Injectable()
export class WebpackTranslationLoader implements TranslateLoader {
  // eslint-disable-next-line rxjs/finnish
  public getTranslation(lang: string): Observable<unknown> {
    return from(import(`./i18n/generated/${lang}.json`));
  }
}
